import React, { Fragment, useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import {
  Button,
  Card,
  CardBody,
  CardText,
  Col,
  Container,
  FormGroup,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import { useInsertConText } from "../Context/InsertContext";
import axios from "axios";
import { GetCookieToken } from "../Cookie/GetCookie";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFViewer,
  Font,
} from "@react-pdf/renderer";
import { useLayOutConText } from "../Context/LayOutContext";
import { FetchAxiosGet } from "../../api/axios";
import LoadingData from "../TESTPage/LoadingData";
import Lottie from "react-lottie";
import * as loadingLeaveSumary from "../../assets/lottieAnimation/loadingLeaveSumary.json"

const dotLineStyle = { borderBottomStyle: "dotted", borderWidth: "2px", display: "inline-block"}

const API_URL = process.env.REACT_APP_API_CORS;
function Form1PDF(props) {
  const {
    budgetYear,
    round,
    evaluateSalaryID,
    userID,
    userName,
    updateApprove,
    task,
    approveId,
    userDepartment,
    version,
    confirmSignnum,
    checkSingnum = true,
    evaluateDataItem,
    approveCheckPointUser,
    checkPointApproved = null,
    lastStepApproved = null,
  } = props;

  let assessor1 = evaluateDataItem?.evaluateSalaryFlow.find(x => x?.assessor === 1)

  const [evaluateData, setEvaluateData] = useState([]);
  const [calculatedValues, setCalculatedValues] = useState(null);
  const [FormData_1, setFormData_1] = useState(null);
  const [dataInfo, setDataInfo] = useState([]);
  const [modal, setModal] = useState(false);
  const [approveInfo, setApproveInfo] = useState([]);
  const [appUser, setAppUser] = useState(null)
  const [positionHighLevel, setPositionHighLevel] = useState(null)
  const [loading, setLoading] = useState(false);
  const [userFullNameLv1, setUserFullNameLv1] = useState(null)
  const [userPosition, setUserPosition] = useState(null)
  const [aproveFullNameLv1, setAproveFullNameLv1] = useState(null)
  const [aprovePosition, setAprovePosition] = useState(null)
  const [evaluateApprove, setEvaluateApprove] = useState(null)

  const toggle = () => setModal(!modal);
 

  const token = GetCookieToken("userToken");


  const fetchStepStatus = async(evaluateSalaryId) =>{
    const params = new URLSearchParams({
          page: 1,
          size: 100,
          "order[0]": "evaluate_salary_approve_id",
          "order[1]": "DESC",
          "filter[evaluate_salary_id][0]": evaluateSalaryId,
        });
    const evaluateApprove = await FetchAxiosGet("/api/evaluateSalaryApprove/datatable",token,params)
    const filteredData = evaluateApprove.result.map(item => ({
      evaluate_status: item.evaluate_status,
      approve_user: item.approve_user,
      approve_user_id: item.approve_user_id
    }));
    let status
    if (task === 1) {
      status = 1
      return status
    } else if(task === 2) {
      // console.log(approveCheckPointUser);
      
      // let approveUser = filteredData?.find(x => x.evaluate_status === task)
      let evaluateFlow = evaluateDataItem?.evaluateSalaryFlow ?? []
      let thisApproveFlow = evaluateFlow?.find(x => x.approve_user_id === approveCheckPointUser?.approve_user_id)
      setAppUser(thisApproveFlow?.approve_user)
      setPositionHighLevel(thisApproveFlow?.approve_user_position_name)
      
      // status = 2
      // return status
      // status = filteredData?.find(x => x.evaluate_status === task)
      // setAppUser(status?.approve_user)
      //   if (status?.approve_user_id !== undefined && status?.approve_user_id !== null) {
      //     const positionApprove = await FetchAxiosGet(`/api/users/${Number(status?.approve_user_id)}`,token)
      //     setPositionHighLevel(positionApprove.result.user_position_name)
      //   }
      // return status?.evaluate_status
    } else if(task === 3) {
      status = 3
      return status
    }
  }

  const fetchEvaluateResult = async () => {
    setLoading(true)
    const status = await fetchStepStatus(evaluateSalaryID)
    const new_buggetyer_migrate = 2568
    const url = `${API_URL}/api/evaluateSalaryResult/datatable`;
    let params 
    // if (status !== undefined && budgetYear >= new_buggetyer_migrate) {
    //   params = new URLSearchParams({
    //     page: 1,
    //     size: 10,
    //     "order[0]": "evaluate_salary_result_id",
    //     "order[1]": "DESC",
    //     "filter[budget_year][0]": budgetYear,
    //     "filter[round][0]": round,
    //     "filter[evaluate_salary_id][0]": evaluateSalaryID,
    //     "filter[user_id][0]": userID,
    //     "filter[step_status][0]": status
    //   });
    // } else {
      params = new URLSearchParams({
        page: 1,
        size: 10,
        "order[0]": "evaluate_salary_result_id",
        "order[1]": "DESC",
        "filter[budget_year][0]": budgetYear,
        "filter[round][0]": round,
        "filter[evaluate_salary_id][0]": evaluateSalaryID,
        "filter[user_id][0]": userID,
        "filter[created_user_id][0]": (lastStepApproved && assessor1) ? assessor1?.approve_user_id : (checkPointApproved ? approveCheckPointUser?.approve_user_id : userID),
        "currentVersion": 1
      });
    // }
      const config = {
        headers: {
          Authorization: `Bearer ${token}`,
        },
        params,
      };
      await axios
        .get(url, config)
        .then(response => {
          const result = response.data.result;

          let maxStep = -Infinity;

          for (const r of result) {
            if (r.step_active > maxStep) {
              maxStep = r.step_active;
            }
          }

          const newData = result.filter(r => r.step_active === maxStep);
          setEvaluateData(newData);
        })
        .catch(error => console.error("Error:", error));
    
    setTimeout(() => {
      setLoading(false)
      }, 2500);
  };

  useEffect(() => {
      fetchEvaluateResult();
  }, [budgetYear,budgetYear,round,evaluateSalaryID,userID,userName,updateApprove,task]);

  useEffect(() => {
    const calculatedValues = evaluateData.map(
      (group, index) => (group.weight * group.score) / 100
    );
    
    const sum = calculatedValues.reduce(
      (accumulator, currentValue) => accumulator + currentValue.toFixed(4) * 1,
      0
    );
    setCalculatedValues(() => sum.toFixed(4));
    setFormData_1((sum * (100 / 5)).toFixed(4));
  }, [evaluateData]);

  const pdfRef = useRef();
  const [buttonLoading, setButtonLoading] = useState(false)
  const downloadPDF = async () => {
    setButtonLoading(true)
    const input = pdfRef.current;
    await html2canvas(input, { scale: 2 }).then(canvas => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("l", "mm", "a4", true);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
      const imgWidth = canvas.width;
      const imgHeight = canvas.height;
      const ratio = Math.min(pdfWidth / imgWidth, pdfHeight / imgHeight);
      const imgX = (pdfWidth - imgWidth * ratio) / 2;

      const imgY = 5;
      pdf.addImage(
        imgData,
        "PNG",
        imgX,
        imgY,
        imgWidth * ratio,
        imgHeight * ratio
      );
      pdf.save("แบบประเมินผลสัมฤทธิ์ของงาน.pdf");
      setTimeout(() => {
        setButtonLoading(false)
      }, 1000);
    });
  };

  // const downloadPDF = async () => {
  //     setButtonLoading(true);
  //     const input = pdfRef.current;

  //     const canvas = await html2canvas(input, {
  //         scale: 3,  // เพิ่ม scale ให้ภาพชัดขึ้น
  //         useCORS: true // รองรับภาพจากแหล่งภายนอก
  //     });

  //     const imgData = canvas.toDataURL("image/png");
  //     const pdf = new jsPDF({
  //         orientation: "l",  // เปลี่ยนเป็นแนวตั้ง (ใช้ "l" ถ้าต้องการแนวนอน)
  //         unit: "mm",
  //         format: "a4",
  //         compress: true
  //     });

  //     const imgWidth = 210;  // A4 width in mm
  //     const imgHeight = (canvas.height * imgWidth) / canvas.width; // คำนวณตามอัตราส่วน

  //     pdf.addImage(imgData, "PNG", 50, 5, imgWidth, imgHeight);
  //     pdf.save("แบบประเมินผลสัมฤทธิ์ของงาน.pdf");

  //     setTimeout(() => {
  //         setButtonLoading(false);
  //     }, 1000);
  // };

  useEffect(() => {
    const url = `${API_URL}/api/users/${userID}`;
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(url, config)
      .then(response => {
        setDataInfo(response.data.result);
      })
      .catch(error => {
        console.error(error);
      });
  }, []);

  useEffect(() => {
    if (updateApprove !== null && updateApprove !== undefined && updateApprove.approve_user_id !== null) {
      const url = `${API_URL}/api/users/${updateApprove.approve_user_id}`;
      const config = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Authorization: `Bearer ${token}`,
        },
      };
      axios
        .get(url, config)
        .then(response => {
          setApproveInfo(response.data.result);
        })
        .catch(error => {
          console.error(error);
        });
    }
  }, []);
  
  const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
  });

  useEffect(() => {
    const handleResize = () => {
      setWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const fetchFullName = async (userID, setFullName, wit = false) => {
    const url = `/api/users/${userID}`;
    let tietleName
    let name
    let fullName
    let witnessUser

    const res = await FetchAxiosGet(url,token).then(ress =>{
      tietleName = ress.result?.user_title_name
      name = ress.result?.user_name
      fullName = `${tietleName}${name}`
      witnessUser = ress.result?.user_position_name
      if (wit) {
        setFullName(witnessUser)
      } else {
        setFullName(fullName)
      }
    }).catch(err => {console.error(err); return null;}) 
  }

  const fetchWitessApporve = async () => {
    const params = new URLSearchParams({
      page: 1,
      size: 100,
      "order[0]": "evaluate_salary_approve_id",
      "order[1]": "ASC",
      "filter[evaluate_salary_id][0]": evaluateSalaryID,
    });
    const evaluateApprove = await FetchAxiosGet("/api/evaluateSalaryApprove/datatable",token,params)
    const index = evaluateApprove?.result.findIndex(x => x.approve_user_id == approveId && x.version == version)
    setEvaluateApprove(evaluateApprove?.result)
  }

  useEffect(() => {
    // fetchFullName(approveId, setAproveFullNameLv1)
    // fetchFullName(approveId, setAprovePosition, true)

    let evaluateFlow = evaluateDataItem?.evaluateSalaryFlow ?? []
    let thisApproveFlow = evaluateFlow?.find(x => x.approve_user_id === approveCheckPointUser?.approve_user_id)
    fetchFullName(thisApproveFlow?.approve_user_id, setAproveFullNameLv1)
    setAprovePosition(thisApproveFlow?.approve_user_position_name)

    fetchFullName(userID, setUserFullNameLv1)
    setUserPosition(evaluateDataItem?.evaluate_user_position_name ?? '-')
    fetchWitessApporve()
  }, [])
  

  return (
    <Fragment>
      <Button
        color="success"
        className="mb-1 text-nowrap"
        onClick={() => {toggle()}}
      >
        แบบฟอร์มที่ 1
      </Button>
      <Modal size="xl" centered isOpen={modal} toggle={toggle}>
        <ModalHeader>
          <div className="position-absolute top-0 end-0">
            <i className="fa-sharp fa-solid fa-circle-xmark pt-2 pe-3 h4" style={{cursor: "pointer"}} onClick={toggle}></i>
          </div>
        </ModalHeader>
        <ModalBody style={{ overflowX: "scroll"}}>
          {loading ? 
          <div>
            <Lottie
              options={{
                loop: true,
                autoplay: true,
                animationData: loadingLeaveSumary.default,
                rendererSettings: {
                  preserveAspectRatio: "xMidYMid slice",
                },
                }}
                width={200}
                height={200}
            />
          </div>
          : <Fragment>
            <div ref={pdfRef} style={{ minWidth:"1106px"}}>
              <Container
                fluid
                className="ps-4 pe-4"
                style={{ fontFamily: "Sarabun,serif"}}
              >
                <Row>
                  <Col lg={12} className="text-end">
                    <i>แบบฟอร์มหมายเลข 1</i>
                  </Col>
                </Row>
                <br />
                <Row className="mt-2">
                  <Col xs={5} md={5} lg={5}>
                    <strong className="border border-2 border-black rounded-3 p-2 shadow-sm fs-5">
                      แบบประเมินผลสัมฤทธิ์ของงาน
                    </strong>
                  </Col>
                  <Col xs={7} md={7} lg={7}>
                      <Row>
                        <Col xs={3} md={3} lg={3}>
                          <strong>รอบการประเมิน</strong>
                        </Col>
                        <Col xs={3} md={3} lg={3}>
                          <strong className="border border-2 border-black p-1 me-2">
                            {round === 1 ? <i className="fa-solid fa-check py-2 p-2 fa-2xl"></i> : <i className="py-2 p-3">&nbsp;</i> }
                          </strong>
                          <strong>รอบที่ 1</strong>
                        </Col>
                        <Col xs={3} md={3} lg={3}>
                          <strong className="border border-2 border-black p-1 me-2">
                            {round === 2 ? <i className="fa-solid fa-check py-2 p-2 fa-2xl"></i> : <i className="py-2 p-3">&nbsp;</i> }
                          </strong>
                          <strong>รอบที่ 2</strong>
                        </Col>
                      </Row>
                  </Col>
                </Row>
                <br />
                <Row >
                  <Col xs={5} md={5} lg={5}>
                    <strong className="pe-3">ชื่อผู้รับการประเมิน</strong>{" "}
                    <span>{userFullNameLv1}</span>
                  </Col>
                  <Col xs={4} md={4} lg={4}>
                    <strong className="pe-3">ตำแหน่ง</strong>{" "}
                    <span>{userPosition} </span>
                  </Col>
                  <Col xs={3} md={3} lg={3}>
                    <strong className="pe-3">ลงนาม</strong>
                    {/* <span>{confirmSignnum} </span> */}
                    <span>{userName}</span>
                  </Col>
                </Row>
                <br />
                <Row  className="mb-2">
                  <Col xs={5} lg={5}>
                    <strong className="pe-3">ชื่อผู้บังคับบัญชา/ผู้ประเมิน</strong>
                    <span>
                      {/* {appUser !== null ? appUser :
                        updateApprove?.approve_user !== undefined &&
                        updateApprove?.approve_user !== null
                          ? updateApprove?.approve_user
                          : "" }  */}
                      {aproveFullNameLv1}
                    </span>
                  </Col>
                  <Col xs={4} md={4} lg={4}>
                    <strong className="pe-3">ตำแหน่ง</strong>{" "}
                    <span>
                      {/* {positionHighLevel !== null ? positionHighLevel :updateApprove !== null && updateApprove !== undefined
                        ? approveInfo.user_position_name
                        : ""} */}
                      {aprovePosition}
                    </span>
                  </Col>
                  <Col xs={3} md={3} lg={3}>
                    <strong className="pe-3">ลงนาม</strong>
                    {/* <span>{checkSingnum && evaluateApprove?.find(x => x.approve_user_id == approveId && x.version == version)?.approve_signnum}</span> */}
                    <span>{checkSingnum && (approveCheckPointUser?.approve_user ?? "")}</span>
                  </Col>
                </Row>
                <table bordered className="border border-1 border-black">
                  <thead>
                    <tr>
                      <th
                        className="text-center"
                        rowSpan="2"
                        style={{verticalAlign:"middle", borderRightWidth:"1px",borderColor:"black"}}
                      >
                        ตัวชี้วัดผลงาน
                        <br />
                      </th>
                      <th colSpan="5" className="text-center p-3" style={{borderRightWidth:"1px",borderColor:"black",borderBottomWidth:"1px"}}>
                        คะแนนตามระดับค่าเป้าหมาย
                      </th>
                      <th
                        rowSpan="2"
                        className="text-center  p-3"
                        style={{borderRightWidth:"1px",borderColor:"black"}}
                      >
                        คะแนน
                        <br />
                        (ก)
                      </th>
                      <th
                        rowSpan="2"
                        className="text-center  p-3"
                        style={{borderRightWidth:"1px",borderColor:"black"}}
                      >
                        น้ำหนัก
                        <br />
                        ร้อยละ
                        <br />
                        (ข)
                      </th>
                      <th
                        rowSpan="2"
                        className="text-center  p-3"
                      >
                        คะแนนรวม
                        <br />
                        (ค=กxข)
                      </th>
                    </tr>
                    <tr>
                      <th className="text-center" style={{borderRightWidth:"1px",borderColor:"black"}}>1</th>
                      <th className="text-center" style={{borderRightWidth:"1px",borderColor:"black"}}>2</th>
                      <th className="text-center" style={{borderRightWidth:"1px",borderColor:"black"}}>3</th>
                      <th className="text-center" style={{borderRightWidth:"1px",borderColor:"black"}}>4</th>
                      <th className="text-center" style={{borderRightWidth:"1px",borderColor:"black"}}>5</th>
                    </tr>
                  </thead>
                  <tbody className="border border-1 border-black" >
                    {evaluateData !== null && evaluateData.length !== 0
                      ? evaluateData
                          .slice()
                          .sort((a, b) => a.no - b.no)
                          .map((group, groupIndex) => (
                            <tr key={groupIndex} className="border border-1 border-black">
                            
                              <td className="border border-1 border-black ps-2">
                                <span>
                                  {group.indicator?.split("\n").map((line, index) => (
                                    <div key={index} >{index === 0 ? `${groupIndex + 1}. ${line}` : line}</div>
                                    ))}
                                </span>
                              </td>

                              <td className="text-center border border-1 border-black">
                                {group.score_1}
                              </td>
                              <td className="text-center border border-1 border-black">
                                {group.score_2}
                              </td>
                              <td className="text-center border border-1 border-black">
                                {group.score_3}
                              </td>
                              <td className="text-center border border-1 border-black">
                                {group.score_4}
                              </td>
                              <td className="text-center border border-1 border-black">
                                {group.score_5}
                              </td>
                              <td
                                className="text-center border border-1 border-black"
                                name={`score_${groupIndex}`}
                              >
                                {group?.score?.toFixed(2)}
                              </td>
                              <td
                                style={{ width: "90px" }}
                                className="text-center border border-1 border-black"
                                name={`weight_${groupIndex}`}
                              >
                                {group?.weight}
                              </td>
                              <td className="text-center border border-black border-1 pb-2">
                                {group?.weight !== "" && group?.score !== "" ? (
                                  <>
                                    {((group?.weight * group?.score) / 100)?.toFixed(
                                      4
                                    )}
                                  </>
                                ) : (
                                  ""
                                )}
                              </td>
                            </tr>
                          ))
                      : ""}
                    <tr className="border border-1 border-black">
                      <td colSpan={8}></td>

                      <td className="text-center border border-1 border-black">
                        {calculatedValues}
                      </td>
                    </tr>
                    <tr>
                      <td className="ps-2" >
                        แปลงคะแนนรวม (ค)
                        ข้างต้นเป็นคะแนนการประเมินผลสัมฤทธิ์ของงานที่มีฐานคะแนนเต็มเป็น
                        100 คะแนน 
                        <br/>
                        [คะแนนการประเมินผลสัมฤทธิ์ (คะแนนเต็ม 100) = (
                        {calculatedValues} * 100) / 5]
                      </td>
                      <td colSpan={7}></td>
                      <td className="text-center border border-1 border-black">
                        {FormData_1}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <table>
                  <thead>
                    <tr className="border border-0 border-black">
                      <th style={{height: "45px"}}>

                      </th>
                    </tr>
                  </thead>
                </table>
              </Container>
            </div>
            <Row>
              <Col xs={8} md={6} lg={4} xl={12}>
                <div className={` 
                  ${windowSize.width < 576 
                    || (windowSize.width >= 576 && windowSize.width < 992 ) 
                    || (windowSize.width >= 992 && windowSize.width < 1200 )
                      ? "text-start ms-4" 
                      : "text-end me-4"
                    }
                `}>
                  <Button disabled={buttonLoading} className="mt-2 " color="success" onClick={downloadPDF}>
                    {buttonLoading === true ? (
                      <i className="bx bx-loader bx-spin font-size-16 align-middle me-2"></i>
                    ) : (
                      <i className="fa-solid fa-print pe-2"></i>
                    )}
                    ดาวน์โหลดแบบฟอร์มที่ 1
                  </Button>
                </div>
              </Col>
            </Row>
          </Fragment> }
        </ModalBody>
      </Modal>
    </Fragment>
  );
}

export default Form1PDF;
